<template>
  <div
    @mouseenter="focusCart"
    :style="{
      top: $route.name == 'store' ? this.canshowRedemption ? '60px' : '130px' : '20px',
      position: 'sticky'
    }"
  >
    <div class="bg-white">
      <div>
        <div v-if="cartItems.length > 0" class="container-fluid p-0">
          <div class="row shopping-cart-clearall">
            <div class="col-md-6">
              <h3 class="text-gray">{{ $t("message.order") }}</h3>
            </div>
            <div class="btn col-md-6 text-right">
              <a
                @click="clearAllOrders()"
                :style="desktopStyles.LinkColorTxt"
              >{{ $t("message.clearAll") }}</a>
            </div>
          </div>
          <hr class="m-0" />
        </div>
        <div class="container">
          <div
            class="row cart-items wholeOrderDiscount"
            v-if="wholeOrderDiscount && wholeOrderDiscountMessage"
          >
            <div
              :style="desktopStyles.successMsg"
              class="discount-container"
            >{{ wholeOrderDiscountMessage }}</div>
          </div>
        </div>
        <div ref="cartWrapper" v-if="cartItems.length > 0" class="cart-items-wrapper">
          <div class="container">
            <template v-for="(item, index) in cartItems">
              <cart-item :cart-item="item" :key="index" :index="index" />
            </template>
          </div>

          <hr v-if="cartItems.length > 0" />
          <div class="container price-container" v-show="cartItems.length > 0">
            <div class="row">
              <div class="col-sm-12 cart-totals">
                <div class="cart-subtotal-label">
                  {{ $t("message.subtotal") }}
                  <small
                    class="fw-600"
                  >({{ cartLength }} {{ $t("message.items") }})</small>
                </div>
                <div class="cart-subtotal-cost">{{ subtotalPrice | formatMoney(currencySign) }}</div>
              </div>
            </div>
            <div v-if="showDelivery" class="row">
              <div class="col-sm-12 cart-totals">
                <div class="cart-subtotal-label">{{ $t("message.delivery") }}</div>
                <div class="cart-subtotal-cost">{{ deliveryFee | formatMoney(currencySign) }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 cart-totals">
                <div class="cart-subtotal-label">{{ taxLabel }}</div>
                <div class="cart-subtotal-cost">{{ totaltax | formatMoney(currencySign) }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 cart-totals">
                <div class="cart-subtotal-label">{{ $t("message.discount") }}</div>
                <div class="cart-subtotal-cost">{{ discount | formatMoney(currencySign) }}</div>
              </div>
            </div>
            <div v-if="!hideSurcharge" class="row">
               <div class="col-sm-12 cart-totals">
                <div class="cart-subtotal-label">{{ surchargeLabel }}</div>
                 <div class="cart-subtotal-cost">{{ getSurchargeAmount | formatMoney(currencySign) }}</div>
               </div>
            </div>
          </div>
        </div>
      </div>

      <hr
        v-show="
          cartItems.length > 0 && cartValue > 0 && $route.name == 'checkout'
        "
      />
      <div v-if="canshowRedemption" class="container">
        <div class="row pt-4">
          <div @click="addReedemption()" class="col-sm-12 checkout">
            <a
              class="btn redeem-btn btn-lg btn-block mb-2"
            >{{ $t("message.redeemStamps") }}: {{ canshowRedemption.Name }}</a>
          </div>
        </div>
      </div>
      <div
        class="container"
        v-show="
          cartItems.length > 0 && cartValue > 0 && $route.name == 'checkout'
        "
      >
        <div class="row">
          <CouponComponent ref="couponComponent" :className="'cart-totals'"></CouponComponent>
        </div>
      </div>
      <hr
        v-show="
          cartItems.length > 0 && cartValue > 0 && $route.name == 'checkout'
        "
      />
      <div class="container">
        <div class="row">
          <div class="col-sm-12 cart-totals" :class="{ 'pb-4': hidePayButton }">
            <div class="total">{{ totalLabel }}</div>
            <div v-if="getPoints" class="cost has-point">
              <span
                class="px-2"
              >{{ totalPrice | formatMoney(currencySign) }}</span>
              <span 
                class="points text-success"
                v-if="storeSupportsLoyaltyPoints"
                >({{ getPoints | formatNumber }} pts)</span>
            </div>
            <div
              v-else
              class="cost"
            >{{ totalPrice | formatMoney(currencySign) }}</div>
          </div>
        </div>
      </div>
      <div v-if="!hidePayButton" class="container">
        <div class="row">
          <div class="col-sm-12 checkout">
            <button
              v-if="!orderMode"
              @click="navigateToCheckout()"
              :disabled="cartItems.length === 0 || storeClosed === true"
              class="btn btn-primary btn-lg btn-block shadow mb-2 d-flex justify-content-center align-items-center"
              :style="desktopStyles.btn"
            >
              {{
              storeClosed ? $t("message.storeClosed") : $t("message.checkout")
              }}
            </button>
            <div
              v-show="storeClosed && store.ClosingStoreMessage"
              class="pt-1"
              v-html="store.ClosingStoreMessage"
            />
            <div
              v-show="storeClosed && !store.ClosingStoreMessage"
              class="pt-1"
            >{{ $t("message.CurrentlyNotTakingOnlineOrders") }}</div>
            <div
              v-show="!exceedMinPurchase && orderMode && !storeClosed"
              class="color-red pt-1 text-center fs-90"
            >
              {{ $t("message.minimumPurchaseIs") }}
              {{ minPurchase | formatMoney(currencySign) }} ({{
              $t("message.excludingDeliveryFee")
              }})
            </div>
            <div
              v-show="showDeliveryDistance"
              class="p-2 color-red text-center fs-90"
            >{{ getDeliveryAddressMessage? getDeliveryAddressMessage: $t("message.DeliveryNotAvailableToThisAddress") }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="orderMode" class="m-4">
      <button
        type="button"
        class="btn btn-block p-2 continue-order-btn"
        @click="continueOrder"
      >{{ $t("message.continueOrdering") }}</button>
    </div>
    <poweredby v-if="!isBranded()" />

    <modal ref="redemptionModal" v-if="showRedemption" full-header @close="closeModal" hide-footer>
      <template slot="body">
        <div style="height: calc(100vh - 100px); overflow-y: auto; margin-bottom: 50px;">
          <Modifiers
            @canceled="closeModal"
            :product="selectedReedemption.product"
            :modifiers="selectedReedemption.modifiers"
            :product-id="selectedReedemption.productId"
            :price-trigger="canshowRedemption"
            @updated="selectRollIntoModiefiers"
            :is-submodifier="true"
            :has-confirm-button="true"
          />
        </div>
      </template>
    </modal>

    <modal ref="privacyModal" v-if="showPrivacyModal" full-header @close="closePrivacyPolicyModal">
      <template slot="body">
        <div class="container">
          <div class="d-flex justify-content-center">
            <h2 class="p-2 mt-2 privacy-header">{{ $t("message.termsAndConditions") }}</h2>
          </div>
          <p class="py-4 terms-and-conditions" v-html="currentStoreDoc.TermsAndConditions"></p>
        </div>
      </template>
      <template slot="footer" class="bg-body">
        <div class="w-100" style="z-index:2">
          <button
            class="privacy-btn pull-right"
            data-dismiss="modal"
            type="button"
            :style="buttonStyles"
            @click="closePrivacyPolicyModal()"
          >{{ $t("message.ok") }}</button>
        </div>
        <div class="privacy-footer" />
      </template>
    </modal>
  </div>
</template>

<script>
import CartItem from "./CartItem";
import poweredby from "../../shared/poweredby";
import CouponComponent from "./CouponComponent";
import modal from "../../modal";
import shared from "../../../sharedscripts/shop/shopping-cart/ShoppingCart.js";
import Modifiers from "../products/Modifiers.vue";
export default {
  name: "ShoppingCart",
  components: {
    CartItem,
    poweredby,
    CouponComponent,
    modal,
    Modifiers
  },
  props: {
    isFromHomePage: {
      type: Boolean,
      default: false
    },
    orderMode: {
      type: Boolean,
      default: false
    },
    proccessing: {
      type: Boolean,
      default: false
    },
    orderType: {
      type: Number,
      default: null
    },
    hidePayButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      IsInOperationMessage: null,
      store: {},
      storeClosed: false,
      dpTimeIsSet: true,
      timerId: null,
      minPurchase: 0,
      selectedReedemption: null,
      showRedemption: false,
      showPrivacyModal: false,
      targetElement: {}
    };
  },
  created() {
    this.store = this.selectedCompany;
    this.checkStoreClosed();
  },
  mounted(){
    this.$root.$emit('settopmenuFromHomePage',this.isFromHomePage) ;
  },
  computed: {
    ...shared.computed
  },
  watch: {
    selectedCompany(newValue) {
      this.store = newValue;
      this.checkStoreClosed();
    },
    orderType(newValue) {
      this.computeRules(newValue);
    },
    totalPrice() {
      this.computeRules(this.orderMode);
    },
    cartItems: {
      handler: function(newValue) {
        this.fixRedemptionQuantity(newValue);
      },
      deep: true
    }
  },
  beforeDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  },
  methods: {
    ...shared.methods,
    openPrivacyPolicyModal() {
      this.showPrivacyModal = true;
    },
    closePrivacyPolicyModal() {
      this.$refs.privacyModal.hideModal();
      this.showPrivacyModal = false;
    }
  }
};
</script>
